"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var expressionsOfInterestStyles_1 = require("./expressionsOfInterestStyles");
var ExpressionItem_1 = require("./ExpressionItem");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var ExpressionsOfInterest = function (_a) {
    var expressionsOfInterest = _a.expressionsOfInterest;
    var styles = expressionsOfInterestStyles_1.default();
    if (!(Array.isArray(expressionsOfInterest) && expressionsOfInterest.length)) {
        return null;
    }
    return (<core_1.Box className={styles.container} data-test="summary:car_details:EOI_container">
      <core_1.Typography data-test="summary:car_details:EOI_sectionLabel">
        <Translation_1.default className={styles.sectionTitle} id="trans__checkout__vehicle_details__expressions_of_interest_label"/>
      </core_1.Typography>
      {expressionsOfInterest.map(function (expression) { return (<ExpressionItem_1.default key={expression.code} id={expression.code} expressionData={expression.attributes}/>); })}
    </core_1.Box>);
};
exports.default = ExpressionsOfInterest;
